import * as React from "react";
import {Video} from "@models/video-content";
import { Rate , Table, Button, Divider, Icon, Tooltip} from "antd";
import {FormattedMessage, intlShape} from "react-intl";
import './index.scss'
import {getFormattedPrice} from '@utils';
import FormattedDateTime from '@components/custom/FormattedDateTime';
import __i18n from "../../../intl/__i18n";
import {PaymentTypeOptions} from "../../../models/paymentType";
import {NavLink} from "react-router-dom";


type Props = {
  data: Video[];
  loading: boolean;
  deleteFn: (item: Video) => void;
  intl: intlShape.isRequired;
  currentPage: number;
};

const ReportList: React.FC<Props> = props => {
  const {data, loading} = props;
  
  const columns = [
    {
      title: <FormattedMessage id="app.index" defaultMessage={`Index`}/>,
      width: 30,
      dataIndex: "id",
      key: "id",
      render: (a, b, i) => <span>{i + 1 }</span>
    },
    {
      title: __i18n("Payment Type"),
      dataIndex: "payment_type",
      key: "payment_type",
      align:"right",
      render:(payment_type) => PaymentTypeOptions.find( item => item.value === payment_type)["label"]
    },
    {
      title: <FormattedMessage id="app.total_count" defaultMessage={`Total Count`}/>,
      dataIndex: "total",
      key: "total",
      align:"left",
    },
    {
      title: "",
      key: "actions",
      width: 150,
      align: "left",
      dataIndex: "actions",
      render: (text, record) => (
        <Tooltip title={<FormattedMessage id="app.report" defaultMessage={`Report`}/>}>
          <NavLink to={`/payments/types/${record.payment_type}/report`}>
            <Button type="link" size={`small`}>
              <Icon type="area-chart"/>
            </Button>
          </NavLink>
        </Tooltip>
      )
    }
  ];
  
  return (
    <Table
      className={'report-table'}
      columns={columns}
      loading={loading}
      pagination={false}
      dataSource={data}
      rowKey="id"
    />
  );
};

export default ReportList;
